import { routerPaths } from '@/router/router-path';
// import { type FallbackLocales } from '@intlify/core-base';

interface GetTranslationNamespaceParams {
  routePath: string;
  messages: Record<string, any>;
  fallbackMessages?: Record<string, any>;
  subbranch?: string;
}

function generateKeyFromRoute(
  routePath: string,
  uppercase: boolean = false,
): { key: string; ids: string[] } {
  const ids: string[] = [];

  const key = routePath
    .split('/')
    .filter(Boolean)
    .map((segment, index) => {
      if (segment.length === 36) {
        ids.push(segment);
        return 'Detail'; // replaces IDs with "Detail"
      }
      return index === 0 ? segment : segment.charAt(0).toUpperCase() + segment.slice(1);
    })
    .join('');

  return {
    key: uppercase ? key.charAt(0).toUpperCase() + key.slice(1) : key,
    ids,
  };
}

/**
 *
 * @param routePath
 * @returns
 */
function deconstructRoutePath(routePath: string): string[] {
  const segments = routePath.split('/').filter(Boolean);
  const paths: string[] = [];

  segments.reduce((accum, segment) => {
    const newPath = `${accum}/${segment}`;
    paths.push(newPath);
    return newPath;
  }, '');

  return paths;
}

/**
 *
 * @param routePath
 * @param messages
 * @returns
 */
export function getTranslationNamespaceByRoute({
  routePath = '',
  messages = {},
  fallbackMessages = {},
  subbranch = '',
}: GetTranslationNamespaceParams): any {
  const deconstructedPaths = deconstructRoutePath(routePath);

  let mergedNamespaces = {};
  let lastValidKey = '';
  let lastValidPath = '';

  const usedNamespaceKeys: Array<{ path: string; namespaceKey: string; hasRoute?: boolean }> = [];

  const mergeNamespaces = (namespaceKey: string) => {
    const namespace = subbranch
      ? messages[subbranch]?.[namespaceKey] || {}
      : messages[namespaceKey] || {};
    const fallbackNamespace = subbranch
      ? fallbackMessages[subbranch][namespaceKey]
      : fallbackMessages[namespaceKey];

    if (namespace && typeof namespace === 'object') {
      mergedNamespaces = {
        ...mergedNamespaces,
        ...fallbackNamespace,
        ...namespace,
      };
    }
  };

  deconstructedPaths.forEach((path) => {
    const routeName = Object.keys(routerPaths).find(
      (key) => routerPaths[key as keyof typeof routerPaths] === path,
    );

    if (routeName) {
      lastValidKey = routeName;
      lastValidPath = path;
      mergeNamespaces(routeName);
      usedNamespaceKeys.push({ path, namespaceKey: routeName, hasRoute: true });
    } else if (lastValidKey) {
      const newPath = path.replace(lastValidPath, '');
      const { key: restKeyFromRoute } = generateKeyFromRoute(newPath.replace(routePath, ''), true);
      const newKey = `${lastValidKey}${restKeyFromRoute}`;
      mergeNamespaces(newKey);
      usedNamespaceKeys.push({ path, namespaceKey: newKey, hasRoute: false });
    }
  });

  return mergedNamespaces;
}
